import type { SvpAssetId } from '@vgtv/api-client/lib/svp_asset';
import { createSelector } from '@reduxjs/toolkit';

import type { Vendor } from '../../types';
import { isTVShowEpisode } from '../../shared/helpers/assetHelpers.js';

import type { AssetsState } from './index';

type State = { assets: AssetsState };

export const selectAssets = (state: State, vendor: Vendor) =>
  state.assets[vendor];

export const selectAssetIdsMap = createSelector(
  (state: State) => state.assets,
  (assets) =>
    Object.entries(assets).map(([vendor, assets]) => {
      return {
        vendor: vendor as Vendor,
        assetIds: Object.keys(assets).map(Number) as SvpAssetId[],
      };
    })
);

export const selectAssetById = (
  state: State,
  vendor: Vendor,
  assetId?: SvpAssetId
) => (assetId ? state.assets[vendor][assetId] : undefined);

export const selectEpisodeById = (
  state: State,
  vendor: Vendor,
  assetId?: SvpAssetId
) => {
  const asset = selectAssetById(state, vendor, assetId);

  return asset && isTVShowEpisode(asset) ? asset : undefined;
};
